/**
 * Where a Topbar Settings menu entry navigates to.
 *
 * People & Access is its own embedded app (`@aimsos/people-access`, mounted at
 * `/people-access/*` in `App.jsx`) and opens on its Members tab. Every other entry
 * keeps the generic `/settings/<id>` route.
 */
const SETTINGS_ROUTES = Object.freeze({
  'people-access': '/people-access/members',
});

/** @param {string} id Settings item id (e.g. `'people-access'`). */
export const getSettingsRoute = (id) => SETTINGS_ROUTES[id] ?? `/settings/${id}`;
